import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import Philosophy from "@/components/sections/Philosophy";
import MarqueeStrip from "@/components/sections/Marquee";
import Ecosystem from "@/components/sections/Ecosystem";
import Oracle from "@/components/sections/Oracle";
import Footer from "@/components/sections/Footer";
import WaitlistDialog from "@/components/WaitlistDialog";
import WelcomeGate from "@/components/WelcomeGate";
import { useAmbientAudio } from "@/context/AudioContext";

const alreadyEntered = () => sessionStorage.getItem("sybil_entered") === "1";

export const OuterVeil = () => {
  const navigate = useNavigate();
  const [waitlistOpen, setWaitlistOpen] = useState(false);
  const [entered, setEntered] = useState(alreadyEntered());
  const { start } = useAmbientAudio();

  const handleEnter = async () => {
    sessionStorage.setItem("sybil_entered", "1");
    setEntered(true);
    try {
      await start();
    } catch (e) {}
    if (window.lenis) window.lenis.scrollTo(0, { immediate: true });
  };

  const handleReturnToEntrance = () => {
    sessionStorage.removeItem("sybil_entered");
    setEntered(false);
    if (window.lenis) window.lenis.scrollTo(0, { immediate: true });
  };

  return (
    <div data-testid="outer-veil">
      <AnimatePresence>
        {!entered && <WelcomeGate onEnter={handleEnter} />}
      </AnimatePresence>

      <Navbar onEnter={() => navigate("/gate")} onBackToEntrance={handleReturnToEntrance} />
      <main>
        <Hero onEnter={() => navigate("/gate")} />
        <Philosophy />
        <MarqueeStrip />
        <Ecosystem />
        <Oracle />
      </main>
      <Footer onJoin={() => setWaitlistOpen(true)} />
      <WaitlistDialog open={waitlistOpen} onClose={() => setWaitlistOpen(false)} />
    </div>
  );
};

export default OuterVeil;
